import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-responsive',
  templateUrl: './nav-responsive.component.html',
  styleUrls: ['./nav-responsive.component.css']
})
export class NavResponsiveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
